import { ISetCharacterParts } from "./../../../models/interactions/SetCharacterParts";
import CharacterPartDefinitionPreview from "./CharacterPartDefinitionPreview";

export default function CharacterPartDefinitionsPreview(props: {
  interaction: ISetCharacterParts;
  onVariantSelected: (partId: string, variantId: string) => void;
  onDelete: (partId: string) => void;
}) {
  const { onVariantSelected, onDelete } = { ...props };

  const definitionsMapped = props.interaction.partDefinitions?.map(
    (definition) => (
      <CharacterPartDefinitionPreview
        key={definition.id}
        definition={definition}
        onVariantSelected={(vId) => onVariantSelected(definition.id, vId)}
        onDelete={() => onDelete(definition.id)}
      />
    )
  );

  return (
    <div className="flex flex-col w-full h-full gap-[8px]">
      <div className={"text-base font-bold text-interaction-primary h-[30px]"}>
        Character Part Pairs
      </div>
      <div className="flex-1 min-h-0 overflow-y-auto pit-scrollbar">
        <div className="grid grid-cols-3 gap-[12px] content-start">
          {definitionsMapped}
        </div>
      </div>
    </div>
  );
}
